export default [
  { to: '/security/traffic', display: 'Traffic analysis' },
];
